@if (form) {
  <select class="form-select"
    [attr.name]="name"
    [formControl]="$safeNavigationMigration(form?.get(name))"
    [ngClass]="ngClass"
    [attr.disabled]="disabled ? true : null"
    >
    @if (defaultDescription) {
      <option [value]="defaultValue">{{ defaultDescription }}</option>
    }
    @for (option of options; track option) {
      <option [value]="option[optionValue]"  [selected]="form?.get(name)?.value == option[optionValue]">
        {{ option[optionText] }}
      </option>
    }
  </select>
} @else {
  <select class="form-select"
    [name]="name"
    [attr.value]="value"
    (change)="valueChanges.emit($event.target.value)"
    [ngClass]="ngClass"
    [attr.disabled]="disabled ? true : null"
    >
    @if (defaultDescription) {
      <option [value]="defaultValue">{{ defaultDescription }}</option>
    }
    @for (option of options; track option) {
      <option [attr.value]="option[optionValue]" [selected]="value == option[optionValue]">
        {{ option[optionText] }}
      </option>
    }
  </select>
}
